import React, { useState } from 'react';
import styled from '@emotion/styled';
import { lightboxCarouselStyles } from '../lightboxStyles';
import ImageCarousel from '../ImageCarousel';

const LightboxWrapper = styled.div`
  ${lightboxCarouselStyles}
`;

interface ImageCarouselLightboxProperties {
  anchorSlides: React.ReactElement[];
  contentSlides: React.ReactElement[];
  width?: string;
}

const ImageCarouselLightbox = ({
  anchorSlides,
  contentSlides,
  width,
}: ImageCarouselLightboxProperties) => {
  const [active, setActive] = useState(0);

  return (
    <LightboxWrapper>
      <light-box>
        <ImageCarousel
          slot="anchor"
          active={active}
          onNavigate={setActive}
          width={width}
        >
          {anchorSlides}
        </ImageCarousel>
        <ImageCarousel
          slot="content"
          active={active}
          onNavigate={setActive}
          width={width}
        >
          {contentSlides}
        </ImageCarousel>
      </light-box>
    </LightboxWrapper>
  );
};

export default ImageCarouselLightbox;
